var site = site || {};

site.direction = site.direction || {};

(function ($) {
  Drupal.behaviors.videoCarouselBlock = {
    attach: function (context) {
      var $main = $('.video-carousel__block', context);
      var $videoCarousel = $('.video-carousel__content', $main);
      var currentSlide = 0;
      var $productGridsContainer = $('.video-carousel__related_products__container', context);

      // mobile menu
      isTouch = Modernizr.touch;

      $videoCarousel.slick({
        rtl: site.direction.isRTL,
        dots: true,
        customPaging: function (slider, i) {
          // return '<button type="button">' + (i + 1) + '</button>';
          var thumb = $(slider.$slides[i]).data('thumbnail');
          var thumbTitle = $(slider.$slides[i]).data('video-title');

          return '<div class="video__image__thumb" style="background-image: url(' + thumb + ')">' + thumbTitle + '</div>';
        },
        nextArrow: '<div class="slick-next"></div>',
        prevArrow: '<div class="slick-prev"></div>',
        slidesToShow: 1,
        slidesToScroll: 1,
        onBeforeChange: function (args) {
          // for pausing videos
          $(document).trigger('videoCarouselAnimate');
        },
        onAfterChange: function (args) {
          // for show and hide product grid containers
          $(document).trigger('videoCarouselAnimateComplete');
        },
        speed: 100,
        draggable: false,
        infinite: false,
        focusOnSelect: true,
        // mobile menu
        responsive: [
          {
            // breakpoint: 767,
            breakpoint: 668,
            settings: {
              dots: false,
              arrows: false,
              swipe: false
            }
          }
        ],
        onInit: function (carousel) {
          // slick arrow images - template content
          var $slickPrevArrow = $('.slick-prev', $main);
          var $slickNextArrow = $('.slick-next', $main);
          // get the image from data attr
          var slickNextImage = $videoCarousel.data('arrow-next-image');
          var slickPrevImage = $videoCarousel.data('arrow-previous-image');

          $slickPrevArrow.css({ 'background-image': 'url(' + slickPrevImage + ')' });
          $slickNextArrow.css({ 'background-image': 'url(' + slickNextImage + ')' });
        }
      });

      // mobile menu
      if (isTouch) {
        var $menu = $('.video-carousel__menu', context);
        var $links = $('.video-block__slide', $main);
        var $select = $('select.video-carousel__menu__selectbox', context);
        var $options = [];

        $menu.removeClass('hidden');

        $links.each(function () {
          var $me = $(this),
            text = $me.text(),
            videoIndex = $me.index();

          $options.push('<option value="' + videoIndex + '">' + text + '</option>');
        });
        $select.append($options);
        site.util.refreshSelectBoxes($select);

        $select.change(function () {
          menuIndex = $(this).val();
          $videoCarousel.slickGoTo(menuIndex);
        });
      } else {
        $('.video-carousel__menu').remove();
      }
      // mobile menu

      // show and hide product grid for each slides and get currentSlide
      $(document).on('ready videoCarouselAnimateComplete', function () {
        currentSlide = $videoCarousel.slickCurrentSlide();
        var productGridSlideContainer = $productGridsContainer[currentSlide];

        $productGridsContainer.not(productGridSlideContainer).addClass('inactive');

        if (productGridSlideContainer) {
          $(productGridSlideContainer).removeClass('hidden inactive');
        }
      });

      // shop button - toggle display of product grids
      $('.video-carousel__related_products__button').on('click', function (e) {
        e.preventDefault();
        var $frp = $($('.video-carousel__related_products')[currentSlide], context);

        // products grids that have been loaded
        $frp.filter(':visible, .active').toggleClass('inactive is-expanded').animate(400, function () {
          $(window).scrollTo($(this), 800, {
            'offset': -69,
            'axis': 'y'
          });
        });

        // Traverse around to the related products wrapper, then slideToggle it
        $frp
          .filter(':hidden')
          .slideToggle(400, function () {
            var $wrapper = $(this);
            var $grid = $('.product-grid--quickshop', $wrapper);
            var bp = Unison.fetch.now().name;

            Drupal.behaviors.productGrid.equalHeights($wrapper);

            // Initialize the product grids
            site.productCarousel.init($wrapper);
            Drupal.behaviors.quickshop.initGrid($grid, bp);

            // Scroll to them
            $(window).scrollTo($wrapper, 800, {
              'offset': -69,
              'axis': 'y'
            });
          }).toggleClass('active is-expanded').removeClass('hidden');
      });
    } // attach
  };
})(jQuery);
